module.exports = __webpack_public_path__ + "img/Group 24@2x.5bc8ada9.png";